import { useState, useEffect } from 'react';
import Modal from './Modal';

const CATEGORIES = [
  'Field Operations',
  'Billing',
  'Standards',
  'Safety',
  'HR'
];

export default function PolicyModal({ isOpen, onClose, onSave, editItem = null }) {
  const [formData, setFormData] = useState({
    name: '',
    url: '',
    category: 'Field Operations'
  });

  useEffect(() => {
    if (editItem) {
      setFormData({
        name: editItem.name || '',
        url: editItem.url || '',
        category: editItem.category || 'Field Operations'
      });
    } else {
      setFormData({
        name: '',
        url: '',
        category: 'Field Operations'
      });
    }
  }, [editItem, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editItem ? 'Edit Policy' : 'Add New Policy'}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <div>
          <label className="block text-sm font-medium mb-2 text-text-secondary">
            Name
          </label>
          <input
            type="text"
            placeholder="e.g., Photo Documentation Policy"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            className="w-full py-3 px-4 bg-surface-elevated border border-border rounded-xl text-sm text-text-primary outline-none focus:border-accent focus:ring-2 focus:ring-accent-muted transition-all placeholder:text-text-muted"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2 text-text-secondary">
            URL
          </label>
          <input
            type="url"
            placeholder="https://drive.google.com/..."
            value={formData.url}
            onChange={(e) => setFormData({ ...formData, url: e.target.value })}
            required
            className="w-full py-3 px-4 bg-surface-elevated border border-border rounded-xl text-sm text-text-primary outline-none focus:border-accent focus:ring-2 focus:ring-accent-muted transition-all placeholder:text-text-muted"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2 text-text-secondary">
            Category
          </label>
          <select
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            className="w-full py-3 px-4 bg-surface-elevated border border-border rounded-xl text-sm text-text-primary outline-none focus:border-accent focus:ring-2 focus:ring-accent-muted transition-all cursor-pointer"
          >
            {CATEGORIES.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 px-5 bg-surface-hover text-text-secondary border border-border rounded-xl text-sm font-medium cursor-pointer hover:bg-surface-active hover:text-text-primary transition-all"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 py-3 px-5 bg-gradient-to-r from-accent to-orange-hover text-surface-base rounded-xl text-sm font-semibold cursor-pointer shadow-lg shadow-accent/20 hover:shadow-accent/30 hover:scale-[1.02] active:scale-[0.98] transition-all"
          >
            {editItem ? 'Save Changes' : 'Add Policy'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
